import React, { useState, useEffect } from "react";
import {
  Link,
  Routes,
  Route,
  Navigate,
  useLocation,
  useNavigate,
} from "react-router-dom";

import { useAuth } from "../../contexts/AuthContext";
import LoadingScreen from "../../components/LoadingScreen/LoadingScreen";

import "../../styles/InnerMenu.scss";
import "./Admin.scss";

import CrmMaster from "./Crm/CrmMaster";
import ErpMaster from "./Erp/ErpMaster";
import InventoryMaster from "./Inventory/InventoryMaster";

const Crm = () => {
  const { hasAnyAuthority, isLoading } = useAuth();
  const [visibleSubmenu, setVisibleSubmenu] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();

  const menuItems = [
    {
      name: "Inventory Master",
      path: "/crm/inventory/master",
      roles: ["ROLE_INVENTORY-MANAGER", "ROLE_ERP-ADMIN", "ROLE_CRM-ADMIN"],
    },
    {
      name: "CRM Master",
      path: "/crm/master",
      roles: ["ROLE_CRM-ADMIN", "ROLE_ERP-ADMIN"],
    },
    {
      name: "ERP Master",
      path: "/crm/erp/master",
      roles: ["ROLE_ERP-ADMIN"],
    },
  ];

  const filteredMenuItems = menuItems.filter((item) =>
    hasAnyAuthority(item.roles),
  );

  useEffect(() => {
    if (isLoading || filteredMenuItems.length === 0) return;

    const isOnAccessiblePath = filteredMenuItems.some((item) =>
      location.pathname.startsWith(item.path),
    );

    // If current path isn't accessible to this user, redirect to first accessible
    if (!isOnAccessiblePath) {
      navigate(filteredMenuItems[0].path, { replace: true });
    }

    // Sync active highlight
    const activeIndex = filteredMenuItems.findIndex((item) =>
      location.pathname.startsWith(item.path),
    );
    if (activeIndex !== -1) setVisibleSubmenu(activeIndex);
  }, [isLoading, filteredMenuItems, location.pathname, navigate]);

  const handleMenuClick = (index) => {
    const item = filteredMenuItems[index];
    setVisibleSubmenu(index);
    navigate(item.path);
  };

  if (isLoading) return <LoadingScreen />;

  return (
    <div className="custom-ess-container">
      <div className="custom-menu">
        {filteredMenuItems.map((item, index) => {
          const isActive =
            visibleSubmenu === index || location.pathname.startsWith(item.path);
          return (
            <div
              key={item.name}
              className={`custom-menu-item ${isActive ? "custom-active" : ""}`}
              onClick={() => handleMenuClick(index)}
            >
              <Link to={item.path} className="custom-menu-link">
                {item.name}
              </Link>
            </div>
          );
        })}
      </div>

      <div className="custom-content">
        <Routes>
          <Route path="master" element={<CrmMaster />} />
          <Route path="erp/master" element={<ErpMaster />} />
          <Route path="inventory/master" element={<InventoryMaster />} />
          <Route
            path="*"
            element={
              <Navigate
                to={filteredMenuItems[0]?.path ?? "/crm/master"}
                replace
              />
            }
          />
        </Routes>
      </div>
    </div>
  );
};

export default Crm;
